import { render, staticRenderFns } from "./PersonalMenu.vue?vue&type=template&id=b7d46170&"
import script from "./PersonalMenu.vue?vue&type=script&lang=ts&"
export * from "./PersonalMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports